import React, { useState } from 'react'
import {
    Card, CardContent, CardActions, Typography, Divider,
    FormControl, InputAdornment, TextField,
    IconButton, Button, Box, Snackbar, Alert,
} from '@mui/material'
import { Auth } from 'aws-amplify';

const ChangeEmail = ({ signOut, user }) => {
    const [loading, setLoading] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const [verificationCode, setVerificationCode] = useState("");
    const [showCode, setShowCode] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [snackbarInfo, setSnackbarInfo] = useState({
        open: false,
        message: "",
        severity: "",
    });

    const currentEmail = user?.attributes?.email;

    const handleEmailChange = (value) => {
        if (newEmail !== "") {
            setEnableSubmit(true);
        }
        setNewEmail(value);
    }

    const handleEmailUpdate = (value) => {

    }

    const handleNext = async () => {

        if (newEmail === '') {
            setSnackbarInfo({
                open: true,
                message: 'New email cannot be null',
                severity: "error",
            });
            return;
        }
        setLoading(true);

        const user = await Auth.currentAuthenticatedUser();
        await Auth.updateUserAttributes(user, {
            email: newEmail
        })
            .then(res => {
                setSnackbarInfo({
                    open: true,
                    message: "Logging out...",
                    severity: "info",
                });

                //setShowCode(true);
                setLoading(false);
                signOut();

            })
            .catch(e => {
                setSnackbarInfo({
                    open: true,
                    message: e.message,
                    severity: "error",
                });
                setShowCode(false);
                setLoading(false);
            })
    }

    const handleCancel = () => {
        setNewEmail("");
        setEnableSubmit(false);
        setShowCode(false);
    }

    const handleClose = () => {
        setSnackbarInfo({ ...snackbarInfo, open: false });
    }

    return (
        <>
            <Card variant='outlined' sx={{
                width: '100%'
            }}>
                <Typography variant='h6' sx={{
                    padding: 2
                }}>Change Email</Typography>
                <Divider></Divider>
                <CardContent>
                    <Box sx={{
                        display: 'flex',
                        padding: 1
                    }}>
                        <Box
                            sx={{
                                padding: 1,
                                width: '60%'
                            }}
                        >
                            {
                                showCode ?
                                    <FormControl
                                        fullWidth
                                        variant="outlined"
                                        sx={{
                                            marginBottom: 2
                                        }}
                                    >
                                        <TextField
                                            size='small'
                                            id="verification-code"
                                            disabled={true}
                                            label="Verification Code"
                                            value={verificationCode}
                                            onChange={(e) => setVerificationCode(e.target.value)}
                                        />
                                    </FormControl>
                                    :
                                    <>
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            sx={{
                                                marginBottom: 2
                                            }}
                                        >
                                            <TextField
                                                size='small'
                                                id="outlined-adornment-password"
                                                disabled={true}
                                                label="Current Email"
                                                value={currentEmail}
                                            />
                                        </FormControl>
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            sx={{
                                                marginBottom: 2
                                            }}
                                        >
                                            <TextField
                                                size='small'
                                                id="outlined-adornment-password"
                                                required={true}
                                                label="New Email"
                                                value={newEmail}
                                                onChange={(e) => handleEmailChange(e.target.value)}
                                            />
                                        </FormControl>
                                    </>
                            }
                        </Box>
                        <Box sx={{
                            padding: 1
                        }}>
                            <Typography>Changing your email will log you out and have you re-login. Once you re-login with you new email address you will have to enter the verification code sent to your email.</Typography>
                            {/* <Typography>Changing your email will first send you an email verification code, once you recieve your code, then input the code on the next step to confirm your email change.</Typography> */}
                        </Box>
                    </Box>
                </CardContent>
                <CardActions>
                    <Button variant='outlined' onClick={() => handleCancel()} > Cancel</Button>
                    <Button variant='outlined' onClick={() => handleNext()}>Update</Button>
                    {/* {showCode && <Button variant='outlined' onClick={() => handleEmailUpdate()}>Update</Button>} */}
                </CardActions>
            </Card >
            <Snackbar open={snackbarInfo.open} autoHideDuration={6000} onClose={() => handleClose()} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={() => handleClose()} severity={snackbarInfo.severity || 'info'} sx={{ width: '100%' }}>
                    {snackbarInfo.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default ChangeEmail